import { render, staticRenderFns } from "./CriticalErrorMessage.vue?vue&type=template&id=5e47da26&scoped=true"
import script from "./CriticalErrorMessage.vue?vue&type=script&lang=js"
export * from "./CriticalErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e47da26",
  null
  
)

export default component.exports